import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import { useEffect, useState } from 'react';

interface JobList {
    itemIndex: number;
    jobId: number;
    eventJob: string;
    customer: string;
    siteAddress: string;
    minScheduleDate: string;
    minScheduleDateFormatted: string;
    amount: number;
    amountFormatted: string;
    paid: boolean;
    isDirty: boolean;
}

const JobsRequiringPaymentData = () => {
    const [searching, setSearching] = useState(false);
    const [jobs, setJobs] = useState<JobList[]>([]);
    const [jobIdSingleSearch, setJobIdSingleSearch] = useState(0);
    const [viewAllJobs, setViewAllJobs] = useState(false);
    const [jobIdSearch, setJobSearchId] = useState(0);
    const [siteAddressSearch, setSiteAddressSearch] = useState("");
    const [customerSearch, setCustomerSearch] = useState("");
    const [sortType, setSortType] = useState(0);
    const [sortDirection, setSortDirection] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const searchSingleJob = () => {
        if (jobIdSingleSearch > 0) {
            setErrorMessage("");
            setJobs([]);
            getSingleJob();
        } else {
            toast.error("Please enter a Job Id before searching.");
        }
    }

    const getSingleJob = async () => {
        const token = await authService.getAccessToken();

        axios.get('api/Job/GetJobsRequiringPaymentSingle?JobId=' + jobIdSingleSearch, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError && res.data.jobs.length === 0) {
                var errors = res.data.messages as any[];
                var errMessage = "";
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                    errMessage += errors[i].content;
                };
                setErrorMessage(errMessage);
            } else {
                var jobsReqPay = res.data.jobs;
                for (var i = 0; i < jobsReqPay.length; i++) {
                    jobsReqPay[i].itemIndex = i;
                }

                setJobs(jobsReqPay);
                if (res.data.isError) {
                    //may have an error with part pickups
                    var errors = res.data.messages as any[];
                    var errMessage = "";
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                        errMessage += errors[i].content;
                    };
                    setErrorMessage(errMessage);
                } else if (jobsReqPay.length === 0) {
                    toast.info("No jobs were found matching your search criteria.");
                    setErrorMessage("No jobs were found matching your search criteria.");
                }
            }
        })
        .catch(error => {
            toast.error(error.message);
            setErrorMessage(error.message);
        });
    }


    const searchPaidJobs = () => {
        if (jobIdSingleSearch > 0) {
            setErrorMessage("");
            setJobs([]);
            setSearching(true);
            getPaidJobs();
        } else {
            toast.error("Please enter a Job Id");
        }
    }

    const getPaidJobs = async () => {
        const token = await authService.getAccessToken();

        axios.get("api/Job/GetPaidScheduledJobs?JobId=" + jobIdSingleSearch, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var paidJobs = res.data;
            for (var i = 0; i < paidJobs.length; i++) {
                paidJobs[i].itemIndex = i;
            }

            setJobs(paidJobs);
            setSearching(false);
        })
        .catch(error => {
            toast.error(error.message);
            setErrorMessage(error.message);
        });
    }

    const showAllJobs = () => {
        setErrorMessage("");
        setJobs([]);
        setViewAllJobs(true);
        getAllJobs(0, 0, false);
    }

    const getAllJobs = async (paySortType: number, sortDir: number, refreshJobs: boolean) => {
        const token = await authService.getAccessToken();

        axios.get('api/Job/GetJobsRequiringPayment?PaymentSortType=' + paySortType + "&sortDirection=" + sortDir + "&refreshJobs=" + refreshJobs, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError && res.data.jobs.length === 0) {
                var errors = res.data.messages as any[];
                var errMessage = "";
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                    errMessage += errors[i].content;
                };
                setErrorMessage(errMessage);
            } else {
                var jobsReqPay = res.data.jobs;
                for (var i = 0; i < jobsReqPay.length; i++) {
                    jobsReqPay[i].itemIndex = i;
                }

                setJobs(jobsReqPay);
                if (res.data.isError) {
                    //may have an error with part pickups
                    var errors = res.data.messages as any[];
                    var errMessage = "";
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                        errMessage += errors[i].content;
                    };
                    setErrorMessage(errMessage);
                }
            }
        })
        .catch(error => {
            toast.error(error.message);
            setErrorMessage(error.message);
        });
    }

    const handleJobIdChange = (e: any) => {
        e.preventDefault();

        let value = e.target.value * 1;
        setJobSearchId(value);
        setCustomerSearch("");
        setSiteAddressSearch("");
    }

    const handleSiteAddrChange = (e: any) => {
        e.preventDefault();

        let value = e.target.value;
        setJobSearchId(0);
        setCustomerSearch("");
        setSiteAddressSearch(value);
    }

    const handleCustChange = (e: any) => {
        e.preventDefault();

        let value = e.target.value;
        setJobSearchId(0);
        setCustomerSearch(value);
        setSiteAddressSearch("");
    }

    const handleCellCheckboxChange = (e: any, itemIndex: number) => {
        var jobList = [...jobs];
        let job = jobList[itemIndex];
        let value = e.target.checked;

        job.paid = value;
        job.isDirty = true;

        setJobs(jobList);
    }

    //Sort Jobs
    const handleSort = (e: any, columnSorted: number, sortDir: number) => {
        e.preventDefault();

        if (sortType == columnSorted) {
            //change direction only
            setSortDirection(sortDir);
        } else {
            //sort new column ascending
            setSortType(columnSorted);
            setSortDirection(sortDir);
        }

        if (columnSorted === 1) {
            var sortedjobs = sortCustomer(sortDir);
            var updatedjobs = updateIndex(sortedjobs);
            setJobs(updatedjobs);
        } else if (columnSorted === 2) {
            var sortedjobs = sortJobId(sortDir);
            var updatedjobs = updateIndex(sortedjobs);
            setJobs(updatedjobs);
        } else if (columnSorted === 3) {
            var sortedjobs = sortAmount(sortDir);
            var updatedjobs = updateIndex(sortedjobs);
            setJobs(updatedjobs);
        } else if (columnSorted === 4) {
            var sortedjobs = sortDate(sortDir);
            var updatedjobs = updateIndex(sortedjobs);
            setJobs(updatedjobs);
        }
    }

    const sortCustomer = (sortDirection: number) => {
        // Always copy the array via spread syntax to prevent state mutation
        return [...jobs].sort((a, b) => {
            const valueA = a.customer;
            const valueB = b.customer;

            return sortDirection === 1
                ? valueA.localeCompare(valueB)
                : valueB.localeCompare(valueA);
        });
    };

    const sortJobId = (sortDirection: number) => {
        // Always copy the array via spread syntax to prevent state mutation
        return [...jobs].sort((a, b) => {
            const valueA = a.jobId;
            const valueB = b.jobId;

            // Handle numerical sort
            return sortDirection === 1 ? valueA - valueB : valueB - valueA;
        });
    }

    const sortAmount = (sortDirection: number) => {
        // Always copy the array via spread syntax to prevent state mutation
        return [...jobs].sort((a, b) => {
            const valueA = a.amount;
            const valueB = b.amount;

            // Handle numerical sort
            return sortDirection === 1 ? valueA - valueB : valueB - valueA;
        });
    }

    const sortDate = (sortDirection: number) => {
        // Always copy the array via spread syntax to prevent state mutation
        return [...jobs].sort((a, b) => {
            const valueA = new Date(a.minScheduleDate).getTime();
            const valueB = new Date(b.minScheduleDate).getTime();

            return sortDirection === 1 ? valueA - valueB : valueB - valueA;

        });
    }

    const updateIndex = (sortedJobs: JobList[]) => {
        for (var i = 0; i < sortedJobs.length; i++) {
            sortedJobs[i].itemIndex = i;
        }
        return sortedJobs;
    }

    //End Sort Jobs

    const resetSearch = () => {
        setSiteAddressSearch("");
        setCustomerSearch("");
        setJobSearchId(0);
        getAllJobs(sortType, sortDirection, false);
    }

    const save = (e: any) => {
        e.preventDefault();

        saveJobs();
    }

    const saveJobs = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let paidJobs = jobs.filter(j => j.isDirty);

        var savePaidJobs = {
            jobs: paidJobs,
            subId: user.sub
        };

        //get list of paid job ids
        var jobsPaidForEmail = paidJobs.filter(p => p.paid);

        //save
        if (paidJobs.length > 0) {
            axios.post('api/Job/SavePaidJobs', savePaidJobs, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    errors.map(function (error: any) {
                        toast.error(error.content);
                    });
                } else {
                    setJobSearchId(0);
                    setCustomerSearch("");
                    setSiteAddressSearch("");
                    if (jobsPaidForEmail.length > 0) {
                        var paidJobIds = jobsPaidForEmail.map(j => j.jobId);
                        emailPaidJobs(paidJobIds);
                    } else {
                        toast.success("Jobs have been updated to Paid");
                        if (viewAllJobs) {
                            getAllJobs(sortType, sortDirection, true);
                        } else {
                            setJobs([]);
                        }
                    }
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        } else {
            toast.error("Select one or more jobs that have been paid");
        }
        
    }

    const emailPaidJobs = async (jobIds: number[]) => {
        const token = await authService.getAccessToken();

        var emailPaidJobs = {
            jobIds: jobIds
        };

        axios.post('api/Job/EmailPaidJobs', emailPaidJobs, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Jobs have been updated to Paid");
            if (viewAllJobs) {
                getAllJobs(sortType, sortDirection, true);
            } else {
                setJobs([]);
            }
        })
        .catch(error => {
            toast.error("Jobs updated to paid, but there was an error while trying to email that the job has been released. Error: " + error.message);
        });
    } 

    const finalJobs = jobIdSearch != 0 ? jobs.filter(j => j.jobId === jobIdSearch) : siteAddressSearch != "" ? jobs.filter(j => j.siteAddress.toLowerCase().indexOf(siteAddressSearch.toLowerCase()) >= 0) : customerSearch != "" ? jobs.filter(j => j.customer.toLowerCase().indexOf(customerSearch.toLowerCase()) >= 0) : jobs;

    const renderDetails = (
        <div>
            <div className="makeitred">Note: when searching by Dash Job Id, you will need to enter the whole Job Id for it to find the job.</div>
            <div className={viewAllJobs ? "hidden" : "" }>
                <label className="input-group--inline" htmlFor="jobIdSearch">
                    <span className="label label--setsizesm">Job Id</span>
                    <input className="input schedulenew__addSearch--width-lg" type="text" id="jobIdSingleSearch" name="jobIdSingleSearch" value={jobIdSingleSearch} onChange={(e) => setJobIdSingleSearch(Number(e.target.value))}></input>
                </label>

                <button className="defaultbutton defaultbutton__large allocate__searchMargin marginLeft10" type="button" onClick={searchSingleJob} disabled={searching}>Search</button>
                <button className="defaultbutton defaultbutton__large allocate__searchMargin marginLeft10" type="button" onClick={searchPaidJobs} disabled={searching}>Search Paid Jobs</button>
                <button className="defaultbutton defaultbutton__large allocate__searchMargin marginLeft10" type="button" onClick={showAllJobs} >View All Jobs</button>
            </div>
            <div className={viewAllJobs ? "makeitflex" : "hidden"}>
                <label className="input-group--inline" htmlFor="jobIdSearch">
                    <span className="label label--setsizesm">Job Id</span>
                    <input className="input schedulenew__addSearch--width-lg" type="text" id="jobIdSearch" name="jobIdSearch" value={jobIdSearch} onChange={(e) => handleJobIdChange(e)}></input>
                </label>
                <label className="input-group--inline" htmlFor="customerSearch">
                    <span className="label label--setsizesm">Customer</span>
                    <input className="input schedulenew__addSearch--width-lg" type="text" id="customerSearch" name="customerSearch" value={customerSearch} onChange={(e) => handleCustChange(e)}></input>
                </label>
                <label className="input-group--inline" htmlFor="siteAddressSearch">
                    <span className="label label--setsizesm">Site Address</span>
                    <input className="input schedulenew__addSearch--width-lg" type="text" id="siteAddressSearch" name="siteAddressSearch" value={siteAddressSearch} onChange={(e) => handleSiteAddrChange(e)}></input>
                </label>

                <button className="defaultbutton defaultbutton__small allocate__searchMargin" type='button' onClick={(e) => resetSearch()}>Reset</button>
                {/*<button className="defaultbutton defaultbutton__large allocate__searchMargin marginLeft10" type="button" onClick={searchPaidJobs} disabled={searching}>Search Paid Jobs</button>*/}
                <span className={searching ? "alignitemscentre marginLeft10" : "hidden"}>Searching Paid Jobs...</span>
            </div>

            <div className={errorMessage === "" ? "hidden" : "makeitred"}>{errorMessage}</div>

            <div className='overflowAuto'>
                <table className='table tableColours'>
                    <thead>
                        <tr>
                            <th>Job Id
                                <i className={sortType === 2 && sortDirection === 1 ? "marginLeft10 fa-solid fa-circle-up" : "hidden"} title="Sort Descending" onClick={(e) => handleSort(e, 2, 2)}></i>
                                <i className={(sortType === 2 && sortDirection === 2) || (sortType != 2) ? "marginLeft10 fa-solid fa-circle-down" : "hidden"} title="Sort Ascending" onClick={(e) => handleSort(e, 2, 1)}></i>
                            </th>
                            <th>Event</th>
                            <th>Customer
                                <i className={sortType === 1 && sortDirection === 1 ? "marginLeft10 fa-solid fa-circle-up" : "hidden"} title="Sort Descending" onClick={(e) => handleSort(e, 1, 2)}></i>
                                <i className={(sortType === 1 && sortDirection === 2) || (sortType != 1) ? "marginLeft10 fa-solid fa-circle-down" : "hidden"} title="Sort Ascending" onClick={(e) => handleSort(e, 1, 1)}></i>
                            </th>
                            <th>Site Address</th>
                            <th>Min Delivery Date
                                <i className={sortType === 4 && sortDirection === 1 ? "marginLeft10 fa-solid fa-circle-up" : "hidden"} title="Sort Descending" onClick={(e) => handleSort(e, 4, 2)}></i>
                                <i className={(sortType === 4 && sortDirection === 2) || (sortType != 4) ? "marginLeft10 fa-solid fa-circle-down" : "hidden"} title="Sort Ascending" onClick={(e) => handleSort(e, 4, 1)}></i>
                            </th>
                            <th className="textalignright">Amount
                                <i className={sortType === 3 && sortDirection === 1 ? "marginLeft10 fa-solid fa-circle-up" : "hidden"} title="Sort Descending" onClick={(e) => handleSort(e, 3, 2)}></i>
                                <i className={(sortType === 3 && sortDirection === 2) || (sortType != 3) ? "marginLeft10 fa-solid fa-circle-down" : "hidden"} title="Sort Ascending" onClick={(e) => handleSort(e, 3, 1)}></i>
                            </th>
                            <th className="textaligncenter">Paid</th>
                        </tr>
                    </thead>
                    <tbody>
                        {finalJobs.map((job, index) =>
                            <tr key={job.jobId}>
                                <td className="table__text--align">
                                    <Link to={'/job/' + job.jobId} target="_blank">{job.jobId}</Link>
                                </td>
                                <td className="table__text--align">{job.eventJob}</td>
                                <td className="table__text--align">{job.customer}</td>
                                <td className="table__text--align">{job.siteAddress}</td>
                                <td className="table__text--align">{job.minScheduleDateFormatted}</td>
                                <td className="table__text--align textalignright">{job.amountFormatted}</td>
                                <td className="table__text--align textaligncenter">
                                    <input type='checkbox' id="paid" name="paid" className='paid' checked={job.paid} onChange={(e) => handleCellCheckboxChange(e, job.itemIndex)}></input>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="colAlignRight marginBottom10">
                <button className="defaultbutton defaultbutton__large" type="button" onClick={save}>Save</button>
            </div>
        </div>
    );

    return (
        <div>
            <h1>Jobs Requiring Payment</h1>
            {renderDetails}
        </div>
    );
}

export default JobsRequiringPaymentData;
